import { render, staticRenderFns } from "./UserInfoNovelties.vue?vue&type=template&id=78fa3b31"
import script from "./UserInfoNovelties.vue?vue&type=script&lang=js"
export * from "./UserInfoNovelties.vue?vue&type=script&lang=js"
import style0 from "./UserInfoNovelties.vue?vue&type=style&index=0&id=78fa3b31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports